(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener(
        'preventHeaderReveal',
        this.hideHeaderOnScrollUp
      );
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      if (this.header.querySelector('details-modal details').hasAttribute("open")) {
        return
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (
        this.headerIsAlwaysSticky &&
        scrollTop > this.header.offsetHeight + 1
      ) {
        this.header.classList.add('shopify-section-header-sticky');
        this.header.style.transform = 'translateY(-100%)';
      }

      if (
        this.headerIsAlwaysSticky &&
        scrollTop > this.header.offsetHeight + 2
      ) {
        this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
        this.header.style.transform = 'translateY(0)';
      }

      if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('shopify-section-header-sticky');
        this.header.style.transform = 'translateY(0)';
        this.header.style.transition = 'background var(--duration-short)';
      }

      if (
        scrollTop > this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        if (this.predictiveSearch && this.predictiveSearch.onFocusOut) {
          this.predictiveSearch.onFocusOut();
          this.predictiveSearch.onBlur();
        }
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (
        scrollTop < this.currentScrollTop &&
        scrollTop > this.headerBounds.bottom
      ) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => disclosure.close());
      }
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('ambient-wishlist-page')) return;

    class AmbientWishlistPage extends HTMLElement {
      connectedCallback() {
        this.rootUrl = this.normalizeRoot(this.dataset.rootUrl || '/');
        this.locale = this.dataset.locale || document.documentElement.lang || 'fr-FR';
        this.currency = this.dataset.currency || 'EUR';
        this.grid = this.querySelector('[data-ah-wishlist-grid]');
        this.loading = this.querySelector('[data-ah-wishlist-loading]');
        this.empty = this.querySelector('[data-ah-wishlist-empty]');
        this.error = this.querySelector('[data-ah-wishlist-error]');
        this.clearButton = this.querySelector('[data-ah-wishlist-clear]');
        this.count = this.querySelector('[data-ah-wishlist-page-count]');
        this.countValue = this.querySelector('[data-ah-wishlist-page-count-value]');
        this.countLabel = this.querySelector('[data-ah-wishlist-page-count-label]');
        this.status = this.querySelector('[data-ah-wishlist-status]');
        this.dialog = this.querySelector('[data-ah-wishlist-dialog]');
        this.renderVersion = 0;
        this.viewTracked = false;

        this.onWishlistChange = () => this.render();
        this.onWishlistReady = () => this.render();
        this.onClick = (event) => this.handleClick(event);
        this.onDialogClose = () => this.handleDialogClose();

        document.addEventListener('ambient:wishlist:change', this.onWishlistChange);
        document.addEventListener('ambient:wishlist:ready', this.onWishlistReady, { once: true });
        this.addEventListener('click', this.onClick);
        this.dialog?.addEventListener('close', this.onDialogClose);

        if (window.AmbientWishlist) this.render();
      }

      disconnectedCallback() {
        document.removeEventListener('ambient:wishlist:change', this.onWishlistChange);
        document.removeEventListener('ambient:wishlist:ready', this.onWishlistReady);
        this.removeEventListener('click', this.onClick);
        this.dialog?.removeEventListener('close', this.onDialogClose);
      }

      normalizeRoot(root) {
        return root.endsWith('/') ? root : `${root}/`;
      }

      async handleClick(event) {
        const clearTrigger = event.target.closest('[data-ah-wishlist-clear]');
        if (clearTrigger) {
          if (typeof this.dialog?.showModal === 'function') {
            this.dialog.showModal();
          } else if (window.confirm('Supprimer tous les favoris ?')) {
            window.AmbientWishlist?.clear();
          }
          return;
        }

        const productLink = event.target.closest('[data-ah-wishlist-product-link]');
        if (productLink) {
          this.trackProductClick(productLink);
          return;
        }

        const cartButton = event.target.closest('[data-ah-wishlist-add-cart]');
        if (!cartButton) return;
        event.preventDefault();
        await this.addToCart(cartButton);
      }

      handleDialogClose() {
        if (this.dialog?.returnValue !== 'confirm') return;
        window.AmbientWishlist?.clear();
        window.AmbientWishlist?.notify('Tous les favoris ont été supprimés');
      }

      async render() {
        if (!window.AmbientWishlist) return;
        const currentVersion = ++this.renderVersion;
        const items = window.AmbientWishlist.getItems();
        if (!this.viewTracked) {
          this.viewTracked = true;
          window.AmbientWishlist.track('wishlist_viewed', {
            wishlist_source: 'wishlist_page',
            wishlist_value: items.reduce((total, item) => total + this.number(item.price), 0) / 100,
            currency: this.currency
          });
        }
        this.updateCount(items.length);
        this.clearButton.hidden = items.length === 0;
        this.error.hidden = true;

        if (items.length === 0) {
          this.loading.hidden = true;
          this.grid.hidden = true;
          this.grid.replaceChildren();
          this.empty.hidden = false;
          this.status.textContent = 'Votre liste de favoris est vide.';
          return;
        }

        this.empty.hidden = true;
        this.grid.hidden = true;
        this.loading.hidden = false;
        this.status.textContent = 'Actualisation de vos favoris…';

        const products = await this.mapWithLimit(items, 6, (item) => this.fetchProduct(item));
        if (currentVersion !== this.renderVersion) return;

        const failedProducts = products.filter((product) => product.fetchFailed);
        const fragment = document.createDocumentFragment();
        products.forEach((product) => {
          fragment.appendChild(this.createCard(product));
        });

        this.grid.replaceChildren(fragment);
        this.loading.hidden = true;
        this.grid.hidden = false;
        this.error.hidden = failedProducts.length === 0;
        this.status.textContent =
          items.length === 1
            ? '1 produit enregistré dans vos favoris.'
            : `${items.length} produits enregistrés dans vos favoris.`;
        window.AmbientWishlist.refresh(this);
      }

      updateCount(count) {
        this.count.hidden = count === 0;
        this.countValue.textContent = String(count);
        this.countLabel.textContent = count === 1 ? 'produit enregistré' : 'produits enregistrés';
      }

      async mapWithLimit(items, limit, worker) {
        const results = new Array(items.length);
        let cursor = 0;

        const runners = Array.from({ length: Math.min(limit, items.length) }, async () => {
          while (cursor < items.length) {
            const index = cursor;
            cursor += 1;
            results[index] = await worker(items[index]);
          }
        });

        await Promise.all(runners);
        return results;
      }

      async fetchProduct(item) {
        try {
          const response = await fetch(
            `${this.rootUrl}products/${encodeURIComponent(item.handle)}.js`,
            {
              credentials: 'same-origin',
              headers: {
                Accept: 'application/json'
              }
            }
          );

          if (!response.ok) throw new Error(`Product request failed: ${response.status}`);
          const product = await response.json();
          const variants = Array.isArray(product.variants) ? product.variants : [];
          const storedVariant = variants.find((variant) => String(variant.id) === String(item.variantId));
          const availableVariant = variants.find((variant) => variant.available);
          const selectedVariant = storedVariant || availableVariant || variants[0] || {};

          return {
            handle: product.handle || item.handle,
            productId: this.number(product.id || item.productId),
            title: product.title || item.title,
            url: product.url || item.url || `${this.rootUrl}products/${item.handle}`,
            image: this.imageSource(product.featured_image || product.images?.[0] || item.image),
            price: this.number(selectedVariant.price ?? product.price ?? item.price),
            compareAtPrice: this.number(
              selectedVariant.compare_at_price ?? product.compare_at_price ?? item.compareAtPrice
            ),
            variantId: this.number(selectedVariant.id || item.variantId),
            currency: item.currency || this.currency,
            available: Boolean(selectedVariant.available ?? product.available ?? item.available),
            hasOneVariant: variants.length === 1,
            vendor: product.vendor || item.vendor,
            description: this.cleanDescription(product.description || item.description),
            fetchFailed: false
          };
        } catch (error) {
          return {
            handle: item.handle,
            productId: this.number(item.productId),
            title: item.title || item.handle,
            url: item.url || `${this.rootUrl}products/${item.handle}`,
            image: this.imageSource(item.image),
            price: this.number(item.price),
            compareAtPrice: this.number(item.compareAtPrice),
            variantId: this.number(item.variantId),
            currency: item.currency || this.currency,
            available: Boolean(item.available),
            hasOneVariant: false,
            vendor: item.vendor,
            description: this.cleanDescription(item.description),
            fetchFailed: true
          };
        }
      }

      imageSource(image) {
        if (!image) return '';
        if (typeof image === 'string') return image;
        return image.src || '';
      }

      number(value) {
        const parsedValue = Number(value);
        return Number.isFinite(parsedValue) ? parsedValue : 0;
      }

      cleanDescription(value) {
        const container = document.createElement('div');
        container.innerHTML = String(value || '');
        const text = container.textContent?.replace(/\s+/g, ' ').trim() || '';
        return text.length > 150 ? `${text.slice(0, 147).trim()}…` : text;
      }

      resizedImage(url) {
        if (!url) return '';
        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}width=900`;
      }

      money(cents) {
        try {
          return new Intl.NumberFormat(this.locale, {
            style: 'currency',
            currency: this.currency
          }).format(this.number(cents) / 100);
        } catch (error) {
          return `${(this.number(cents) / 100).toFixed(2)} ${this.currency}`;
        }
      }

      escape(value) {
        return String(value || '')
          .replaceAll('&', '&amp;')
          .replaceAll('<', '&lt;')
          .replaceAll('>', '&gt;')
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#039;');
      }

      transitionName(handle) {
        return `ah-wishlist-${String(handle || '').replace(/[^a-zA-Z0-9_-]/g, '-')}`;
      }

      trackingAttributes(product) {
        return [
          'data-ah-wishlist-product-link',
          'data-wishlist-source="wishlist_page"',
          `data-product-handle="${this.escape(product.handle)}"`,
          `data-product-id="${this.number(product.productId)}"`,
          `data-product-title="${this.escape(product.title)}"`,
          `data-product-price="${this.number(product.price)}"`,
          `data-product-variant-id="${this.number(product.variantId)}"`,
          `data-product-vendor="${this.escape(product.vendor)}"`,
          `data-product-currency="${this.escape(product.currency || this.currency)}"`
        ].join(' ');
      }

      analyticsDataFromElement(element) {
        const product = {
          handle: element.dataset.productHandle,
          productId: element.dataset.productId,
          title: element.dataset.productTitle,
          price: element.dataset.productPrice,
          variantId: element.dataset.productVariantId,
          vendor: element.dataset.productVendor,
          currency: element.dataset.productCurrency || this.currency
        };

        return {
          wishlist_source: element.dataset.wishlistSource || 'wishlist_page',
          ...window.AmbientWishlist?.toAnalyticsItem(product)
        };
      }

      trackProductClick(link) {
        window.AmbientWishlist?.track(
          'wishlist_product_clicked',
          this.analyticsDataFromElement(link)
        );
      }

      createCard(product) {
        const article = document.createElement('article');
        article.className = 'ah-wishlist-card';
        article.style.setProperty('--ah-wishlist-transition-name', this.transitionName(product.handle));

        const productUrl = this.escape(product.url);
        const title = this.escape(product.title);
        const handle = this.escape(product.handle);
        const image = this.escape(this.resizedImage(product.image));
        const vendor = this.escape(product.vendor);
        const description = this.escape(product.description);
        const showVendor = this.dataset.showVendor === 'true' && vendor;
        const showDescription = this.dataset.showDescription === 'true' && description;
        const comparePrice =
          product.compareAtPrice > product.price
            ? `<span class="ah-wishlist-card__compare-price">${this.escape(this.money(product.compareAtPrice))}</span>`
            : '';
        const media = image
          ? `<img class="ah-wishlist-card__image" src="${image}" alt="${title}" loading="lazy" width="900" height="1125">`
          : `<span class="ah-wishlist-card__placeholder" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 5h16v14H4zM4 16l4.5-4.5 3 3 2-2 6.5 6.5"/></svg></span>`;
        const soldOutBadge = product.available
          ? ''
          : `<span class="ah-wishlist-card__badge">${this.escape(this.dataset.labelSoldOut)}</span>`;
        const action = this.cardAction(product, productUrl);
        const trackingAttributes = this.trackingAttributes(product);

        article.innerHTML = `
          <a class="ah-wishlist-card__media" href="${productUrl}" aria-label="${title}" ${trackingAttributes}>
            ${media}
            ${soldOutBadge}
          </a>
          <div class="ah-wishlist-card__content">
            <div class="ah-wishlist-card__top">
              <div>
                ${showVendor ? `<p class="ah-wishlist-card__vendor">${vendor}</p>` : ''}
                <h2 class="ah-wishlist-card__title"><a href="${productUrl}" ${trackingAttributes}>${title}</a></h2>
                ${showDescription ? `<p class="ah-wishlist-card__description">${description}</p>` : ''}
              </div>
              <button
                type="button"
                class="ah-wishlist-toggle ah-wishlist-toggle--card ah-wishlist-card__remove is-active"
                aria-pressed="true"
                aria-label="Retirer ${title} des favoris"
                title="Retirer des favoris"
                data-ah-wishlist-toggle
                data-product-handle="${handle}"
                data-product-id="${this.number(product.productId)}"
                data-product-title="${title}"
                data-product-url="${productUrl}"
                data-product-image="${this.escape(product.image)}"
                data-product-price="${product.price}"
                data-product-compare-at-price="${product.compareAtPrice}"
                data-product-variant-id="${product.variantId}"
                data-product-currency="${this.escape(product.currency || this.currency)}"
                data-product-available="${product.available}"
                data-product-vendor="${vendor}"
                data-product-description="${description}"
                data-wishlist-source="wishlist_page"
                data-label-add="Ajouter ${title} aux favoris"
                data-label-remove="Retirer ${title} des favoris"
                data-message-add="Ajouté aux favoris"
                data-message-remove="Retiré des favoris"
              >
                <svg class="ah-wishlist-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                  <path class="ah-wishlist-icon__heart" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"></path>
                </svg>
                <span class="visually-hidden" data-ah-wishlist-label>Retirer ${title} des favoris</span>
              </button>
            </div>
            <div class="ah-wishlist-card__footer">
              <div class="ah-wishlist-card__price">
                <span>${this.escape(this.money(product.price))}</span>
                ${comparePrice}
              </div>
              ${action}
            </div>
          </div>
        `;

        return article;
      }

      cardAction(product, productUrl) {
        const trackingAttributes = this.trackingAttributes(product);
        if (!product.available) {
          return `<a class="ah-wishlist-card__action" href="${productUrl}" ${trackingAttributes}>${this.escape(this.dataset.labelView)}</a>`;
        }

        if (product.hasOneVariant && product.variantId) {
          return `
            <button
              type="button"
              class="ah-wishlist-card__action"
              data-ah-wishlist-add-cart
              data-variant-id="${product.variantId}"
              data-wishlist-source="wishlist_page"
              data-product-handle="${this.escape(product.handle)}"
              data-product-id="${this.number(product.productId)}"
              data-product-title="${this.escape(product.title)}"
              data-product-price="${this.number(product.price)}"
              data-product-variant-id="${this.number(product.variantId)}"
              data-product-vendor="${this.escape(product.vendor)}"
              data-product-currency="${this.escape(product.currency || this.currency)}"
            >
              ${this.escape(this.dataset.labelAddCart)}
            </button>
          `;
        }

        return `<a class="ah-wishlist-card__action" href="${productUrl}" ${trackingAttributes}>${this.escape(this.dataset.labelOptions)}</a>`;
      }

      async addToCart(button) {
        const variantId = Number(button.dataset.variantId);
        if (!variantId || button.disabled) return;
        const initialLabel = button.textContent.trim();
        const analyticsData = this.analyticsDataFromElement(button);
        const wishlistId = window.AmbientWishlist?.getWishlistId() || '';
        button.disabled = true;
        button.textContent = this.dataset.labelAdding;

        try {
          const response = await fetch(`${this.rootUrl}cart/add.js`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [
                {
                  id: variantId,
                  quantity: 1,
                  properties: {
                    _ah_wishlist_source: 'wishlist_page',
                    _ah_wishlist_id: wishlistId,
                    _ah_wishlist_product_id: String(button.dataset.productId || ''),
                    _ah_wishlist_variant_id: String(variantId)
                  }
                }
              ]
            })
          });

          if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
          button.textContent = this.dataset.labelAdded;
          window.AmbientWishlist?.notify(this.dataset.messageCart);
          window.AmbientWishlist?.track('wishlist_added_to_cart', analyticsData);
          await this.refreshCartCount();
          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: {
                source: 'wishlist'
              }
            })
          );
        } catch (error) {
          button.textContent = initialLabel;
          window.AmbientWishlist?.notify(this.dataset.messageCartError);
        } finally {
          window.setTimeout(() => {
            button.disabled = false;
            button.textContent = initialLabel;
          }, 1800);
        }
      }

      async refreshCartCount() {
        try {
          const response = await fetch(`${this.rootUrl}cart.js`, {
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json'
            }
          });
          if (!response.ok) return;
          const cart = await response.json();
          document.querySelectorAll('.cart-count-bubble').forEach((bubble) => {
            bubble.classList.toggle('cart-have-count', cart.item_count > 0);
            const visibleCount = bubble.querySelector('[aria-hidden="true"]');
            if (visibleCount) visibleCount.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count);
          });
        } catch (error) {
          return;
        }
      }
    }

    customElements.define('ambient-wishlist-page', AmbientWishlistPage);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();
		}

			connectedCallback() {

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then((response) => response.text())
					.then((text) => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector(
							'product-recommendations'
						);
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}

						/* Color swatches */
						const generateSrcset = (image, widths = []) => {
							const imageUrl = new URL(image['src']);
							return widths
								.filter((width) => width <= image['width'])
								.map((width) => {
									imageUrl.searchParams.set('width', width.toString());
									return `${imageUrl.href} ${width}w`;
								})
								.join(', ');
						};

						const createImageElement = (
							image,
							classes,
							sizes,
							productTitle
						) => {
							const previewImage = image['preview_image'];
							const newImage = new Image(
								previewImage['width'],
								previewImage['height']
							);
							newImage.className = classes;
							newImage.alt = image['alt'] || productTitle;
							newImage.sizes = sizes;
							newImage.src = previewImage['src'];
							newImage.srcset = generateSrcset(
								previewImage,
								[165, 360, 533, 720, 940, 1066]
							);
							newImage.loading = 'lazy';
							return newImage;
						};

						const checkSwatches = () => {
							document
								.querySelectorAll('.js-color-swatches-wrapper')
								.forEach((wrapper) => {
									wrapper
										.querySelectorAll('.js-color-swatches input')
										.forEach((input) => {
											input.addEventListener('click', (event) => {
												const primaryImage =
													wrapper.querySelector('.media--first');
												const secondaryImage =
													wrapper.querySelector('.media--second');
												const handleProduct = wrapper.dataset.product;

												if (event.currentTarget.checked && primaryImage) {
													wrapper
														.querySelector('.js-color-swatches-link')
														.setAttribute(
															'href',
															event.currentTarget.dataset.variantLink
														);
													if (
														wrapper.querySelector(
															'.card__add-to-cart button[name="add"]'
														)
													) {
														wrapper
															.querySelector(
																'.card__add-to-cart button[name="add"]'
															)
															.setAttribute('aria-disabled', false);
														wrapper
															.querySelector(
																'.card__add-to-cart button[name="add"] > span'
															)
															.classList.remove('hidden');
														wrapper
															.querySelector(
																'.card__add-to-cart button[name="add"] .sold-out-message'
															)
															.classList.add('hidden');
														wrapper.querySelector(
															'.card__add-to-cart input[name="id"]'
														).value = event.currentTarget.dataset.variantId;
													}

													const currentColor = event.currentTarget.value;

													jQuery.getJSON(
														window.Shopify.routes.root +
															`products/${handleProduct}.js`,
														function (product) {
															const variant = product.variants.filter(
																(item) =>
																	item.featured_media != null &&
																	item.options.includes(currentColor)
															)[0];

															if (variant) {
																const newPrimaryImage = createImageElement(
																	variant['featured_media'],
																	primaryImage.className,
																	primaryImage.sizes,
																	product.title
																);

																if (newPrimaryImage.src !== primaryImage.src) {
																	let flag = false;
																	if (secondaryImage) {
																		const secondaryImagePathname = new URL(
																			secondaryImage.src
																		).pathname;
																		const newPrimaryImagePathname = new URL(
																			newPrimaryImage.src
																		).pathname;

																		if (
																			secondaryImagePathname ==
																			newPrimaryImagePathname
																		) {
																			primaryImage.remove();
																			secondaryImage.classList.remove(
																				'media--second'
																			);
																			secondaryImage.classList.add(
																				'media--first'
																			);
																			flag = true;
																		}
																	}
																	if (flag == false) {
																		primaryImage.animate(
																			{ opacity: [1, 0] },
																			{
																				duration: 200,
																				easing: 'ease-in',
																				fill: 'forwards',
																			}
																		).finished;
																		setTimeout(function () {
																			primaryImage.replaceWith(newPrimaryImage);
																			newPrimaryImage.animate(
																				{ opacity: [0, 1] },
																				{ duration: 200, easing: 'ease-in' }
																			);
																			if (secondaryImage) {
																				secondaryImage.remove();
																			}
																		}, 200);
																	}
																}
															}
														}
													);
												}
											});
										});
								});
						};

						const initProductCarouselSliders = () => {
							const prodCarslideshows = document.querySelectorAll(
								'.product-recommendations-swiper'
							);

							prodCarslideshows.forEach((prodSlideshow) => {
								const productCount = parseInt(
									prodSlideshow
										.querySelector('.swiper-wrapper')
										.getAttribute('data-count')
								);

								const productCountMobile = parseInt(
									prodSlideshow
										.querySelector('.swiper-wrapper')
										.getAttribute('data-count-mobile')
								);

								const prodCardprodSlideshow = new Swiper(prodSlideshow, {
									loop: false,
									autoHeight: true,
									allowTouchMove: true,
									slidesPerView: productCount,
									lazy: true,
									preloadImages: false,
									spaceBetween: 24,
									navigation: {
										nextEl: '.swiper-button-next',
										prevEl: '.swiper-button-prev',
									},
									on: {
										resize: function () {
											var windowWidth = window.innerWidth;

											if (productCount == 6) {
												if (windowWidth < 576) {
													this.params.slidesPerView = productCountMobile;
												} else if (windowWidth < 750) {
													this.params.slidesPerView = 2;
												} else if (windowWidth < 1100) {
													this.params.slidesPerView = 3;
												} else if (windowWidth < 1360) {
													this.params.slidesPerView = 4;
												} else if (windowWidth < 1600) {
													this.params.slidesPerView = 5;
												} else {
													this.params.slidesPerView = 6;
												}
											} else if (productCount == 5) {
												if (windowWidth < 576) {
													this.params.slidesPerView = productCountMobile;
												} else if (windowWidth < 750) {
													this.params.slidesPerView = 2;
												} else if (windowWidth < 1100) {
													this.params.slidesPerView = 3;
												} else if (windowWidth < 1360) {
													this.params.slidesPerView = 4;
												} else {
													this.params.slidesPerView = 5;
												}
											} else if (productCount == 4) {
												if (windowWidth < 576) {
													this.params.slidesPerView = productCountMobile;
												} else if (windowWidth < 750) {
													this.params.slidesPerView = 2;
												} else if (windowWidth < 1100) {
													this.params.slidesPerView = 3;
												} else {
													this.params.slidesPerView = 4;
												}
											} else if (productCount == 3) {
												if (windowWidth < 576) {
													this.params.slidesPerView = productCountMobile;
												} else if (windowWidth < 750) {
													this.params.slidesPerView = 2;
												} else {
													this.params.slidesPerView = 3;
												}
											} else if (productCount == 2) {
												if (windowWidth < 576) {
													this.params.slidesPerView = productCountMobile;
												} else {
													this.params.slidesPerView = 2;
												}
											}
										},
									},
								});
							});
						};

						checkSwatches();
						initProductCarouselSliders();
					})
					.catch((e) => {
						console.error(e);
					});
			};

			new IntersectionObserver(handleIntersection.bind(this), {
				rootMargin: '0px 0px 200px 0px',
			}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
